import { RenderOptions, RenderResult, render } from '@testing-library/preact';
import { RootEnvironment, RootEnvironmentProvider } from '../../UNSAFE_Environment';

import { ComponentProps } from 'preact';
import translations from '../../resources/nls/en/bundle';

type RootEnvironmentProviderProps = ComponentProps<typeof RootEnvironmentProvider>;

const defaultEnvironment: Partial<RootEnvironment> = {
  translations: { '@oracle/oraclejet-preact': translations },
  mode: 'test'
};

export const renderInEnv = (
  children: RootEnvironmentProviderProps['children'],
  environment = defaultEnvironment,
  options?: Omit<RenderOptions, 'queries'>
) => {
  const mergedEnvironment = { ...environment };
  if (mergedEnvironment.translations == null) {
    mergedEnvironment.translations = {
      ...defaultEnvironment.translations
    };
  }

  const { rerender: _rerender, ...result } = render(
    <RootEnvironmentProvider environment={mergedEnvironment}>{children}</RootEnvironmentProvider>,
    options
  );
  const rerender = (children: RootEnvironmentProviderProps['children']) =>
    _rerender(
      <RootEnvironmentProvider environment={mergedEnvironment}>{children}</RootEnvironmentProvider>
    );
  return { rerender, ...result } as RenderResult;
};
